import { typedFrontendVendorApi } from "@vendor-app/utils/typedFrontendVendorApi";
import { ThemeGatewayInterface } from "./interface";

export default class ThemeGateway implements ThemeGatewayInterface {
  public async getFile(themeId: string, fileName: string) {
    try {
      const response = await typedFrontendVendorApi.getReq(`/theme/:themeId/file`, {
        params: {
          themeId,
        },
        query: {
          fileName,
        },
      });

      if (response.type !== "success") {
        throw new Error(`There was an error fetching the theme file: ${response.message}`);
      }

      return response.body;
    } catch (error) {
      throw new Error(`There was an error fetching the theme file: ${error}`);
    }
  }

  public async validate(themeId: string, fileName: string): Promise<boolean> {
    try {
      const response = await typedFrontendVendorApi.getReq(`/theme/:themeId/file/validate`, {
        params: {
          themeId,
        },
        query: {
          fileName,
        },
      });

      if (response.type !== "success") {
        return false;
      }

      return response.body;
    } catch {
      throw new Error(`Unable to validate theme.`);
    }
  }

  public async verifyAppBlock(themeId: string, fileName: string): Promise<boolean> {
    try {
      const response = await typedFrontendVendorApi.getReq(`/theme/:themeId/file/verify-subscription-app-block`, {
        params: {
          themeId,
        },
        query: {
          fileName,
        },
      });

      if (response.type !== "success") {
        return false;
      }

      return response.body;
    } catch {
      throw new Error(`Unable to verify app block implementation.`);
    }
  }
}
